export * from "./ranking-produtos.component";
